import React from 'react';
import {BrowserRouter as Router, Route} from 'react-router-dom';
import propTypes from 'prop-types';
import App from './App';

export default function AppRoute(props) {
    return (
        <Router basename={window.__POWERED_BY_QIANKUN__?props.activeRule:"/"}>
            <Route path="/">
                <App/>
            </Route>
        </Router>
    );
}

AppRoute.propTypes = {
    activeRule: propTypes.string
};

AppRoute.defaultProps = {
    activeRule: '/'
};